import { render, staticRenderFns } from "./QrConfig.vue?vue&type=template&id=1a9c744a&scoped=true"
import script from "./QrConfig.vue?vue&type=script&lang=js"
export * from "./QrConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9c744a",
  null
  
)

export default component.exports